import React, { useState, useEffect, Fragment } from "react";
// import { useStateWithCallbackLazy } from "use-state-with-callback";
import { useHistory, useLocation } from "react-router-dom";
import {
  Col,
  Form,
  Container,
  Row,
  Modal,
  Image,
  Button,
} from "react-bootstrap";
import { TextField, FormControl, Select } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import { MuiThemeProvider, createTheme } from "@material-ui/core/styles";
//import { PaymentSuccessModel } from "../../Orders/OrderRequest/RightComponentOrderRequest";
import moment from "moment";
import Alert from "react-s-alert";
import { EVENT_RAZORPAY_KEY } from "../../../../config/Keys";

import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
// import { connect } from "react-redux";
// import { withRouter } from "react-router-dom";
import { useFormik } from "formik";
import * as yup from "yup";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import isEmpty from "../../../../store/validation/is-Empty";
import { add_rsvp_events } from "../../../../store/actions/RsvpEventDashboard/RsvpEventDashboardAction";
import {
  razor_pay_create_order,
  razor_payment,
} from "../../../../store/actions/OrderingAction/vendorOrderingAction";
import { rsvp_edit_perticular_event_request } from "../../../../store/actions/RsvpEventDashboard/RsvpEventDashboardAction";
//import { NewInputText } from "../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { TRANSACTION_ID } from "../../../../store/types";
import store from "../../../../store/store";
import CashModal from "../../../reusableComponents/CashModalComponent";

//custom Hook
function usePrevious(data) {
  const ref = React.useRef();
  React.useEffect(() => {
    ref.current = data;
  }, [data]);
  return ref.current;
}

const validationSchema = yup.object({
  mobile_number: yup.string().required("Mobile number is required"),
  name: yup.string().required("name is required"),
  email: yup.string().email(),
});

const EventPaymentMain = (props) => {
  let history = useHistory();
  // let location = useLocation();

  const [open, setOpen] = useState(false);
  const [displayCustomInput, setDisplayCustomInput] = useState(false);
  const [selectedValue, setSelectedValue] = React.useState("");
  const [getSingleEventInfo, setGetSingleEventInfo] = useState({});
  useEffect(() => {
    setGetSingleEventInfo(props.singleEventData);
  }, [props.singleEventData]);

  const [state, setState] = useState({
    code: "",
    emailChecked: false,
    donates: [
      { id: 0, title: "No", value: 0 },
      { id: 1, title: "₹ 10", value: 10 },
      { id: 2, title: "₹ 50", value: 50 },
      { id: 3, title: "₹ 100", value: 100 },
    ],
    donate_Amount_Value: 0,
    transactional_id: 0,
    allFormData: {},
    eventId: 0,
    payment_pending: false,
  });

  const [onlinePayment, setOnlinePayment] = useState(true);

  const [showCancel, setShowCancel] = useState(false);
  const [showCashModal, setShowCashModal] = useState(false);

  const [externalRef, setExternalRef] = useState("");

  const submitExternal = (data) => {
    setExternalRef(data);
    setShowCancel(false);
  };

  const loadScript = (src) => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  };

  const onChange = (e) => {
    let data = e.target.value.split(" ");
    let newarray1 = [];
    for (let x = 0; x < data.length; x++) {
      newarray1.push(data[x].charAt(0).toUpperCase() + data[x].slice(1));
    }
    let newData = newarray1.join(" ");
    setState({
      ...state,
      [e.target.name]: newData,
    });
  };

  const onCheckboxHandle = (e) => {
    setState({
      ...state,
      emailChecked: !state.emailChecked,
    });
  };
  const adultPrice = parseInt(
    props?.price?.adult || getSingleEventInfo.adult_price || 0
  );
  const adultPeople = props.ticketData && props.ticketData.adult_count;
  const kidsPrice = parseInt(
    props?.price?.child || getSingleEventInfo.child_price || 0
  );
  const kidsPeople = props.ticketData && props.ticketData.kids_count;
  const combinedAdultPrice = adultPrice * adultPeople;
  const combinedKidsPrice = kidsPrice * kidsPeople;
  const totalPeoplePrice =
    combinedAdultPrice + combinedKidsPrice + state.donate_Amount_Value;

  let oldAmount = 0;
  if (props?.price.adult || props?.price?.child) {
    const adultPrice = parseInt(getSingleEventInfo.adult_price || 0);
    const adultPeople = props.ticketData && props.ticketData.adult_count;
    const kidsPrice = parseInt(getSingleEventInfo.child_price || 0);
    const kidsPeople = props.ticketData && props.ticketData.kids_count;
    const combinedAdultPrice = adultPrice * adultPeople;
    const combinedKidsPrice = kidsPrice * kidsPeople;
    oldAmount =
      combinedAdultPrice + combinedKidsPrice + state.donate_Amount_Value;
  }

  useEffect(() => {
    setState({
      ...state,
      code: !isEmpty(props.auth.user.VendorUser.country_code)
        ? props.auth.user.VendorUser.country_code
        : "",
    });
    if (
      props.ticketData &&
      props.ticketData.user_details &&
      props.ticketData.user_details.mobile_number !== undefined &&
      props.ticketData.user_details.mobile_number !== null
    ) {
      formik.setFieldValue(
        "mobile_number",
        props.ticketData &&
          props.ticketData.user_details &&
          props.ticketData.user_details.mobile_number
      );
    }
    if (
      props.ticketData &&
      props.ticketData.user_details &&
      props.ticketData.user_details.name !== undefined &&
      props.ticketData.user_details.name !== null
    ) {
      formik.setFieldValue(
        "name",
        props.ticketData &&
          props.ticketData.user_details &&
          props.ticketData.user_details.name
      );
    }
    if (
      props.ticketData &&
      props.ticketData.user_details &&
      props.ticketData.user_details.email !== undefined &&
      props.ticketData.user_details.email !== null
    ) {
      formik.setFieldValue(
        "email",
        props.ticketData &&
          props.ticketData.user_details &&
          props.ticketData.user_details.email
      );
    }
  }, []);

  const formik = useFormik({
    initialValues: {
      code: "",
      mobile_number: "",
      name: "",
      email: "",
      paymentMethod: "",
      payment_data: {},
      donate_amount: "",
      cash_amount: "",
      service_charge: 0,
      tax_charge: 0,
      payment_status: "",
    },
    validationSchema,

    onSubmit: (values) => {
      var token = props.auth.user.accessToken;
      var paymentMethod =
        // selectedValue === "6" || selectedValue === "0"
        //   ? ""
        //   :
        parseInt(selectedValue);
      var formData = {};
      formData.event_id = props.ticketData && props.ticketData.event_id;
      formData.vendor_id = props.ticketData && props.ticketData.vendor_id;
      formData.restaurant_id =
        props.ticketData && props.ticketData.restaurant_id;
      formData.kids_count = props.ticketData && props.ticketData.kids_count;
      formData.adult_count = props.ticketData && props.ticketData.adult_count;
      formData.handicap_chair =
        props.ticketData && props.ticketData.handicap_chair;
      formData.high_chair = props.ticketData && props.ticketData.high_chair;
      formData.room_number = props.ticketData && props.ticketData.room_number;
      formData.seat_number = props.ticketData && props.ticketData.seat_number;
      formData.occasion = props.ticketData && props.ticketData.occasion;
      // parseInt(state.wait_time.split("-")[1]);
      formData.event_type = "TICKET_BOOKED";
      formData.event_status = "INITIAL";
      formData.service_type = "SEATING";
      formData.pointOfEntry = "VENDOR";
      formData.user_details = {
        country_code:
          props.ticketData &&
          props.ticketData.user_details &&
          props.ticketData.user_details.country_code,
        mobile_number:
          props.ticketData &&
          props.ticketData.user_details &&
          props.ticketData.user_details.mobile_number,
        name:
          props.ticketData &&
          props.ticketData.user_details &&
          props.ticketData.user_details.name,
        userId:
          props.ticketData &&
          props.ticketData.user_details &&
          props.ticketData.user_details.userId,
        email:
          props.ticketData &&
          props.ticketData.user_details &&
          props.ticketData.user_details.email,
      };
      formData.payment_data = {
        code: state.code,
        mobile_number: values.mobile_number,
        name: values.name,
        emailChecked: state.emailChecked,
        email: values.email,
        service_Charge: values.service_charge,
        payment_method: parseInt(selectedValue),
        tax_charge: values.tax_charge,
        // donate_amount: state.donate_Amount_Value,
        donation: {
          amount: state.donate_Amount_Value,
        },
        total_amount: totalPeoplePrice,
      };
      if ((props?.price?.adult || props?.price?.child) && oldAmount) {
        formData.payment_data.oldAmount = oldAmount;
      }
      if (selectedValue == 8) {
        formData.payment_data.transactionRef = externalRef;
      }
      formData.payment_status = 0;
      // selectedValue === "6" || selectedValue === "0"
      //   ? 0
      //   : parseInt(selectedValue);
      // if (paymentMethod !== "") {
      // formData.payment_data.payment_method = parseInt(selectedValue);
      // }
      // console.log(formData);
      store.dispatch({ type: TRANSACTION_ID, payload: formData });
      if (![1, 2, 3, 4, 5].includes(parseInt(selectedValue))) {
        formData.event_status = "PENDING";
        formData.payment_status = 1;
        props.add_rsvp_events(formData, token, onSuccess);
      } else if ([1, 2, 3, 4, 5].includes(parseInt(selectedValue))) {
        let onInitailCreate = (formData, id) => {
          displayRazorpay(
            formData.payment_data.donation.amount,
            formData.payment_data.total_amount,
            formData.user_details.userId,
            formData.user_details.name,
            formData.user_details.mobile_number,
            formData.user_details.email,
            getSingleEventInfo._id,
            id
          );
        };
        props.add_rsvp_events(formData, token, onInitailCreate);
      }
      // onClickProceed(formData);
    },
  });

  const onSuccess = (data, eventId) => {
    // if (
    //   data.payment_data.payment_method === 0 ||
    //   data.payment_data.payment_method === 6
    // ) {
    Alert.success("<h4>Event Added Successfully</h4>", {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    let id = props.eventId;
    history.push({
      pathname: `/offline-events-booked/${id}`,
      state: { offlineEventInformation: id },
    });
    // } else {
    //   displayRazorpay(
    //     data.payment_data.donation.amount,
    //     data.payment_data.total_amount,
    //     data.user_details.userId,
    //     data.user_details.name,
    //     data.user_details.mobile_number,
    //     data.user_details.email,
    //     eventId
    //   );
    // }
    //this.props.history.push("/orderdashboard");
    //
  };

  // const onSuccessAddEvent = () => {
  //   Alert.success("<h4>Event Added Successfully</h4>", {
  //     position: "top-right",
  //     effect: "bouncyflip",
  //     beep: true,
  //     html: true,
  //     timeout: 3000,
  //     offset: 35,
  //   });
  //   let id = props.eventId;
  //   history.push({
  //     pathname: `/offline-events-booked/${id}`,
  //     state: { offlineEventInformation: id },
  //   });
  // };

  // const onClickProceed = (formData) => {
  //   if (
  //     formData.payment_data.payment_method === 4 ||
  //     (formData.payment_data.payment_method === 3 && onlinePayment)
  //   ) {
  //     // razro pay
  //     displayRazorpay(
  //  donationAmount,      formData.payment_data.total_amount,
  //       "5f9cfd745aff896d55449b03",
  //       formData.user_details.name,
  //       formData.user_details.mobile_number,
  //       "shinde786gaurav@gmail.com",
  //       getSingleEventInfo._id
  //       // formData.user_details.userId,
  //       // formData.user_details.email
  //     );
  //   } else {
  //     const token = props.auth.user.accessToken;
  //     if (
  //       formData.payment_data.payment_method === 4 ||
  //       formData.payment_data.payment_method === 3
  //     ) {
  //       formData.transactional_id = state.transactional_id;
  //       props.add_rsvp_events(formData, token, () => onSuccessPayment());
  //     } else {
  //       props.add_rsvp_events(formData, token, () => onSuccessPayment());
  //     }
  //   }
  // };

  // const prevCount = usePrevious(state.transactional_id);

  async function displayRazorpay(
    donationAmount,
    total,
    userId,
    name,
    phoneNo,
    email,
    eventId,
    handlerId
  ) {
    const res = await loadScript(
      "https://checkout.razorpay.com/v1/checkout.js"
    );
    if (!res) {
      alert("Razorpay SDK failed to load. Are you online?");
      return;
    }
    const onSuccess = (data) => {
      setState({
        ...state,
        transactional_id: data.transactional._id,
        eventId: eventId,
      });
      const onSuccessHandler = (response, data) => {
        const formData = {
          razorpay_payment_id: response.razorpay_payment_id,
          transactional_id: data.transactional._id,
          event_status: "PENDING",
          isEvent: true,
          //order_id: orderId,
          ransaction_type: "RAZORPAY",
          currency: "INR",
          user_id: userId,
          restaurant_id: props.onboarding._id,
          event_id: eventId,
        };
        if (donationAmount) {
          formData.donation = {};
          formData.donation.amount = donationAmount;
        }
        props.razor_payment(
          props.auth.user.accessToken,
          formData,
          onSuccessCallFinalApi,
          handlerId
        );
      };

      const onFailure = (response) => {
        const formData = {};
        formData.payment_status = 3;
        formData.event_status = "PENDING";
        formData.transactional_id = data.transactional._id;
        formData.razorpay_payment_id = response.error.metadata.payment_id;
        const token = props.auth.user.accessToken;
        props.rsvp_edit_perticular_event_request(formData, handlerId, token);
      };

      const options = {
        key: EVENT_RAZORPAY_KEY,
        currency: data.currency,
        amount: data.amount.toString(),
        donation: {
          amount: data && data.donation && data.donation.amount.toString(),
        },
        order_id: data.id,
        name: "Amealio",
        description: "Amealio Ordering Payment",
        method: {
          netbanking: false,
          card: true,
          wallet: false,
          upi: false,
        },
        handler: function (response) {
          onSuccessHandler(response, data);
        },
        prefill: {
          name: name,
          email: email,
          contact: phoneNo,
        },
      };
      const paymentObject = new window.Razorpay(options);
      paymentObject.open();
      paymentObject.on("payment.failed", function (response) {
        onFailure(response);
      });
    };

    const formData = {
      amount: parseFloat(total).toFixed(2),
      donation: {
        amount: parseFloat(donationAmount),
      },
      user_id: userId,
      refModel: "User",
      message: "Testing payment",
      currency: "INR",
      isEvent: true,
      receipt: eventId,
    };
    const token = props.auth.user.accessToken;
    // console.log(formData);
    props.razor_pay_create_order(token, formData, onSuccess, eventId);
  }

  const onSuccessCallFinalApi = (data, handlerId) => {
    setState({ ...state, transactional_id: data._id });
    setOnlinePayment(false);
    const formData = {};
    formData.transactional_id = data._id;
    formData.payment_status = 1;
    formData.event_status = "PENDING";
    const token = props.auth.user.accessToken;
    props.rsvp_edit_perticular_event_request(
      formData,
      handlerId,
      token,
      onSuccessPayment
      // token, formData, eventId
    );
  };

  const onSuccessPayment = () => {
    Alert.success("<h4>Event Added Successfully</h4>", {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    let id = props.eventId;
    history.push({
      pathname: `/offline-events-booked/${id}`,
      state: { offlineEventInformation: id },
    });
  };

  // useEffect(() => {
  //   if (onlinePayment === false) {
  //     onClickProceed(props.allData);
  //   } else {
  //     console.log("No threshold reached.");
  //   }
  // }, [onlinePayment]);

  const [successPayment, setSuccessPayment] = useState({});

  const [count, setCount] = useState(1);
  const onClickSave = () => {
    if (selectedValue === 8 && !externalRef) {
      Alert.error("<h4>Please Enter Reference Data</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else {
      setCount(count + 1);
      formik.handleSubmit();
    }
  };

  useEffect(() => {
    if (
      props.ticketData &&
      props.ticketData.user_details &&
      props.ticketData.user_details.mobile_number !== undefined &&
      props.ticketData.user_details.mobile_number !== null
    ) {
      formik.setFieldValue(
        "mobile_number",
        props.ticketData &&
          props.ticketData.user_details &&
          props.ticketData.user_details.mobile_number
      );
    }
    if (
      props.ticketData &&
      props.ticketData.user_details &&
      props.ticketData.user_details.email !== undefined &&
      props.ticketData.user_details.email !== null
    ) {
      formik.setFieldValue(
        "email",
        props.ticketData &&
          props.ticketData.user_details &&
          props.ticketData.user_details.email
      );
    }
  }, []);

  const onCustomeButton = (e) => {
    setDisplayCustomInput(!displayCustomInput);
  };

  const onAddDonateAmount = (e) => {
    const totalDonateAmount = state.donates;
    const donate_amount = formik.values.donate_amount;
    let id = totalDonateAmount[totalDonateAmount.length - 1].id;
    if (donate_amount === "") {
      Alert.error("<h4>Donate Amount is Required</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else if (totalDonateAmount.some((amount) => amount === donate_amount)) {
      Alert.error("<h4>Donate Amount Already Exits</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else {
      totalDonateAmount.push({
        id: id + 1,
        title: `₹ ${donate_amount}`,
        value: donate_amount,
      });
      setState({
        ...state,
        donates: totalDonateAmount,
      });
      formik.setFieldValue("donate_amount", "");
    }
  };

  const addOnClickAmount = (data) => {
    setState({
      ...state,
      donate_Amount_Value: data.value,
    });
  };

  const cashAmountBalance = totalPeoplePrice - formik.values.cash_amount;

  const selectPayment = (id) => {
    if (id === 8) {
      setShowCancel(true);
    } else if (id === 9) {
      setShowCashModal(true);
    }
    setSelectedValue(id);
  };

  return (
    <React.Fragment>
      <Col md={8}>
        <MuiThemeProvider theme={theme}>
          <Container fluid>
            <h3 className="py-3">Payment</h3>
            <div style={{ paddingTop: "2%" }}>
              <Row>
                <Col xs={4} sm={4} md={2} lg={2} xl={2}>
                  <Form.Group controlId={"code"}>
                    <div className="input-phone-country-code-reusable w-100">
                      <select
                        name="code"
                        value={state.code}
                        onChange={onChange}
                        className="w-100"
                      >
                        <option value={state.code}>{state.code}</option>
                        {getCountries().map((country) => (
                          <option
                            key={country}
                            value={"+" + getCountryCallingCode(country)}
                          >
                            {en[country]} (+{getCountryCallingCode(country)})
                          </option>
                        ))}
                      </select>
                    </div>
                  </Form.Group>
                </Col>
                <Col xs={8}>
                  <Form.Group>
                    <TextField
                      id="mobile_number"
                      label="Phone Number"
                      type="number"
                      variant="outlined"
                      className={`w-100 ${
                        formik.errors.mobile_number &&
                        formik.touched.mobile_number
                          ? "enError"
                          : ""
                      }`}
                      onInput={(e) => {
                        e.target.value = Math.max(0, parseInt(e.target.value))
                          .toString()
                          .slice(0, 10);
                      }}
                      name="mobile_number"
                      onChange={formik.handleChange}
                      value={formik.values.mobile_number}
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.mobile_number &&
                    formik.touched.mobile_number ? (
                      <div className="pho_14_regular text-danger">
                        {formik.errors.mobile_number}
                      </div>
                    ) : null}
                  </Form.Group>
                </Col>
              </Row>
              <br />
              {/* <PhoneComponent mobile_number={"1234567890"} country_code={"+91"} /> */}
              <div className="row">
                <Col md={5}>
                  <Form.Group>
                    <TextField
                      id="name"
                      label="Name"
                      type="text"
                      variant="outlined"
                      className={`w-100 ${
                        formik.errors.name && formik.touched.name
                          ? "enError"
                          : ""
                      }`}
                      inputProps={{
                        maxLength: 64,
                      }}
                      name="name"
                      onChange={formik.handleChange}
                      value={formik.values.name}
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.name && formik.touched.name ? (
                      <div className="pho_14_regular text-danger">
                        {formik.errors.name}
                      </div>
                    ) : null}
                  </Form.Group>
                  {/* <Row> */}
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={state.emailChecked}
                        color="primary"
                        onChange={(e) => onCheckboxHandle(e)}
                        name="emailChecked"
                        id="emailChecked"
                      />
                    }
                    label="Would you like to get receipt in email?"
                  />
                  {/* </Row> */}
                </Col>
                {state.emailChecked ? (
                  <Col md={5}>
                    <Form.Group>
                      <TextField
                        id="email"
                        label="E-mail Address"
                        type="text"
                        variant="outlined"
                        className={`w-100 ${
                          formik.errors.email && formik.touched.email
                            ? "enError"
                            : ""
                        }`}
                        inputProps={{
                          maxLength: 64,
                        }}
                        name="email"
                        onChange={formik.handleChange}
                        value={formik.values.email}
                        onBlur={formik.handleBlur}
                      />
                      {formik.errors.email && formik.touched.email ? (
                        <div className="pho_14_regular text-danger">
                          {formik.errors.email}
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                ) : null}
              </div>
              <hr />
              <Container fluid>
                <Row>
                  <div className="f16-500 mb-2">
                    {getSingleEventInfo.name}{" "}
                    <span className="badge badge-warning ml-4 text-white">
                      {getSingleEventInfo.isOnline ? "" : "Offline"}
                    </span>
                  </div>
                </Row>
                <Row>
                  <div className="f12-400" style={{ color: "#EE3A23" }}>
                    Event ID: {getSingleEventInfo.event_id}
                  </div>
                </Row>
                <br />
                <Row style={{ backgroundColor: "#ffffff", padding: "15px" }}>
                  <Col md={3} className="d-flex justify-content-between">
                    <span style={{ color: "#757575" }}>Start Date</span>
                    <br />
                    <b>
                      {moment(getSingleEventInfo.start_date).format(
                        "Do MMM YYYY"
                      )}
                    </b>
                  </Col>
                  <Col md={3} className="d-flex justify-content-between">
                    <span style={{ color: "#757575" }}>Time</span>
                    <br />
                    <b>
                      {moment(getSingleEventInfo.start_date).format("hh : mm")}
                    </b>
                  </Col>

                  <Col md={3} className="d-flex justify-content-between">
                    <span style={{ color: "#757575" }}> Tickets</span>

                    <br />
                    <b>
                      {props.ticketData &&
                        props.ticketData.adult_count +
                          props.ticketData.kids_count}
                    </b>
                  </Col>
                </Row>
                <Row className="p-3" style={{ backgroundColor: "#FFF3CF" }}>
                  <Col md={10} className="d-flex justify-content-between">
                    {props?.ticketData?.seating_preference !== "" ? (
                      <div className="f14-700  align-items-center">
                        Seating Preference{": "}
                        <p className="ml-2 ">
                          {props?.ticketData?.seating_preference}
                        </p>
                      </div>
                    ) : (
                      <div className="f14-700  align-items-center">
                        Seat Number{" "}
                        <p className="ml-2">
                          {props.ticketData &&
                            props.ticketData.seat_number.map((seat, index) => {
                              return (
                                <React.Fragment key={index}>
                                  {seat},{" "}
                                </React.Fragment>
                              );
                            })}
                        </p>
                      </div>
                    )}
                    <div className="f14-700">
                      {props.ticketData && props.ticketData.adult_count} Adults
                      | {props.ticketData && props.ticketData.kids_count} Child
                    </div>
                  </Col>
                  <Col md={2}>
                    {/* <button
                    className="pl-3 pr-3"
                    style={{
                      boxShadow: "0px 5px 8px #6E6E6E57",
                      borderRadius: "15px",
                      backgroundColor: "#2196F3",
                      color: "#ffffff",
                      border: "none",
                    }}
                  >
                    Edit
                  </button> */}
                  </Col>
                </Row>
                {/* {props.cart_data && props.cart_data.length > 0 ? ( */}
                <Row
                  style={{
                    backgroundColor: "#FFFBEE",
                    padding: "15px",
                    display: "flex",
                    alignItems: "center",
                  }}
                  className="d-flex justify-content-between align-middle"
                >
                  <Col md={10} className="d-flex justify-content-between">
                    <p style={{ color: "#212121" }}>Total Amount To Be Paid</p>
                    <p className="f14-700">
                      {/* ₹ {calcFinalTotal(props.cart_data)} */}₹{" "}
                      {totalPeoplePrice && totalPeoplePrice}
                    </p>
                  </Col>
                  <Col md={2}></Col>
                </Row>
                {/* ) : (
                <Fragment></Fragment>
              )} */}
                <hr />
                <h5>Select payment method</h5>
                <br />
                {paymentData.map((data, index) => {
                  return (
                    <Fragment key={index}>
                      {data.show ? (
                        <PaymentsInfo
                          data={data}
                          selectedValue={selectedValue}
                          handlePaymentType={selectPayment}
                        />
                      ) : (
                        <Fragment></Fragment>
                      )}
                    </Fragment>
                  );
                })}
              </Container>
            </div>
          </Container>
        </MuiThemeProvider>
      </Col>
      <Col md={4} style={{ backgroundColor: "#ffffff" }}>
        <Container className="mt-4">
          <Row>
            <Col xs={10}>
              <div className="f16-500">Customer Order Details </div>
            </Col>
            <Col xs={2}>
              <div className="f12-700" style={{ color: "#EE3A23" }}>
                Edit
              </div>
            </Col>
          </Row>
          <Row className="mt-3  align-items-center">
            <Col xs={1} className="icons-for-border-black">
              <Image
                src={require("../../../../assets/images/superadmin/ordericon/1-03.svg")}
                width="20px"
              />
            </Col>
            <Col xs={10}>
              <div className="f12-500">
                {props.ticketData && props.ticketData.user_details.name}
              </div>
            </Col>
          </Row>
          <Row className="mt-3  align-items-center">
            <Col xs={1} className="icons-for-border-black">
              <Image
                src={require("../../../../assets/images/superadmin/ordericon/1-02.svg")}
                width="20px"
              />
            </Col>
            <Col xs={10}>
              <div className="f12-500">
                {props.ticketData &&
                  props.ticketData.user_details.country_code +
                    " " +
                    props.ticketData.user_details.mobile_number}
              </div>
            </Col>
          </Row>
          <Container
            fluid
            className="mt-4 pt-4 pb-4"
            style={{ backgroundColor: "#FFFBEE" }}
          >
            <Row>
              <Col xs={8}>
                {" "}
                <h4>Want to Donate to Smiles?</h4>
              </Col>
              <Col
                xs={4}
                className="f10-700"
                style={{ color: "#2196F3", cursor: "pointer" }}
              >
                Learn More
              </Col>
            </Row>
            <Row
              style={{ marginLeft: "3%" }}
              className="superadmin-orderscomponent-main"
            >
              {state.donates.map((data) => {
                return (
                  <Col
                    xs={3}
                    sm={3}
                    md={3}
                    className="p-0 mt-3 mr-2"
                    align="center"
                    onClick={() => addOnClickAmount(data)}
                    key={data.id}
                  >
                    <div
                      className={`f12-400 take-away-order-select 
                                   ${
                                     state.donate_Amount_Value === data.value &&
                                     `take-away-order-select-selected`
                                   }
                                `}
                      style={{
                        padding: "10px",
                        marginRight: "1%",
                        marginBottom: "1%",
                      }}
                    >
                      {data.title}
                    </div>
                  </Col>
                );
              })}
              {displayCustomInput ? (
                <div className="row mt-3">
                  <Col md={4}>
                    <TextField
                      id="donate_amount"
                      label="Amount"
                      type="number"
                      variant="outlined"
                      onInput={(e) => {
                        e.target.value = Math.max(0, parseInt(e.target.value))
                          .toString()
                          .slice(0, 10);
                      }}
                      name="donate_amount"
                      onChange={formik.handleChange}
                      value={formik.values.donate_amount}
                      onBlur={formik.handleBlur}
                    />
                  </Col>
                  <Col md-5>
                    <button
                      className="pl-3 pr-3"
                      style={{
                        boxShadow: "0px 5px 8px #6E6E6E57",
                        borderRadius: "15px",
                        backgroundColor: "#2196F3",
                        color: "#ffffff",
                        border: "none",
                      }}
                      onClick={() => onAddDonateAmount()}
                    >
                      Add
                    </button>
                  </Col>
                </div>
              ) : (
                <Col
                  xs={3}
                  sm={3}
                  md={3}
                  className="p-0 mt-3 mr-2"
                  align="center"
                  onClick={() => onCustomeButton()}
                >
                  <div
                    className={"f12-400 take-away-order-select"}
                    style={{
                      padding: "10px",
                      marginRight: "1%",
                      marginBottom: "1%",
                    }}
                  >
                    Custom
                  </div>
                </Col>
              )}
            </Row>
          </Container>
          <div className="mt-3 mb-3">
            <h4 className="f16-700">Order Summary</h4>
          </div>
          <Row className="mt-2">
            <Col>
              <div className="f12-400">Sub Total</div>
            </Col>
            <Col align="right">
              <div className="f12-400">
                ₹ {totalPeoplePrice && totalPeoplePrice}
              </div>
            </Col>
          </Row>
          {/* <Row className="mt-2">
            <Col md={6}>
              <div className="f12-400">Service Charge</div>
            </Col>
            <Col md={6} align="right">
              <div className="f12-400">₹{formik.values.service_charge}</div>
            </Col>
          </Row>
          <Row className="mt-2">
            <Col md={6}>
              <div className="f12-400">GST</div>
            </Col>
            <Col md={6} align="right">
              <div className="f12-400">₹{formik.values.tax_charge}</div>
            </Col>
          </Row> */}
          <hr />
          <Row className="mt-2">
            <Col>
              <div className="f12-400">Donate Amount</div>
            </Col>
            <Col align="right">
              <div className="f12-400">₹{state.donate_Amount_Value}</div>
            </Col>
          </Row>
        </Container>
        <div className="mt-2 pt-2 pb-2" style={{ backgroundColor: "#F8F8F8" }}>
          <Container>
            <Row>
              <Col md={6}>
                <div className="f14-700">To Pay</div>
              </Col>
              <Col md={6} align="right">
                <div className="f14-700">
                  ₹ {totalPeoplePrice && totalPeoplePrice}
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        {selectedValue === "0" ? (
          <div className="mt-2 pt-2">
            <Container>
              <Row>
                <Col
                  sm={12}
                  md={12}
                  lg={12}
                  className="d-flex justify-content-between align-self-center py-3"
                >
                  <div className="col-4 f14-700 p-0">Cash Amount</div>
                  <div className="col-5 p-0">
                    <TextField
                      id="cash_amount"
                      label="Enter Cash Amount"
                      type="number"
                      variant="outlined"
                      onInput={(e) => {
                        e.target.value = Math.max(0, parseInt(e.target.value))
                          .toString()
                          .slice(0, 10);
                      }}
                      name="cash_amount"
                      onChange={formik.handleChange}
                      value={formik.values.cash_amount}
                      onBlur={formik.handleBlur}
                    />
                  </div>
                </Col>
                <Col
                  sm={12}
                  md={12}
                  lg={12}
                  className="py-3 d-flex justify-content-between"
                  style={{ backgroundColor: "#F3F3F3" }}
                >
                  <span className="f14-500">
                    {/* {formik.values.cash_amount < totalPeoplePrice
                      ? "Not Return Any Amount"
                      : " */}
                    Balance to Return :{/* "} */}
                  </span>
                  <span
                    className="f14-700"
                    style={{
                      color:
                        formik.values.cash_amount < totalPeoplePrice
                          ? "#212121"
                          : "#EE3A23",
                    }}
                  >
                    {formik.values.cash_amount === ""
                      ? ""
                      : formik.values.cash_amount < totalPeoplePrice
                      ? ""
                      : `₹${Math.abs(cashAmountBalance)}`}
                  </span>
                </Col>
              </Row>
            </Container>
          </div>
        ) : (
          ""
        )}

        <div className="row py-3 px-3 mt-3 justify-content-center border">
          <div className="col-6">
            <button
              type="button"
              className="onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
              title="Cancel Button"
              onClick={() =>
                history.push(
                  `/offline-events-booked/${getSingleEventInfo?._id}`
                )
              }
            >
              Cancel
            </button>
          </div>
          <div className="col-6">
            <button
              type="button"
              className="onboarding_button_link_reusable onboarding_button_link_reusable_red"
              title="Save Button"
              disabled={selectedValue === "" ? true : false}
              // onClick={() => {
              //   setOpen(true);
              // }}
              onClick={() => onClickSave()}
            >
              Proceed
            </button>
          </div>
          <PaymentSuccessFailedModel
            open={open}
            // props={props}
            success={true}
            paymentSuccessData={successPayment}
            setOpenTract={() => {
              setOpen(false);
            }}
          />
          {showCancel && (
            <ExternalReference
              hideCancel={() => setShowCancel(false)}
              submitExternal={submitExternal}
            />
          )}
          {showCashModal && (
            <CashModal
              hideModal={() => setShowCashModal(false)}
              events
              total={totalPeoplePrice}
              cartData={[
                [
                  {
                    item: { name: "Adult Ticket" },
                    quantity: adultPeople,
                    finalPrice: adultPrice,
                  },
                ],
                [
                  {
                    item: { name: "Kid Ticket" },
                    quantity: kidsPeople,
                    finalPrice: kidsPrice,
                  },
                ],
              ]}
              userData={{
                order_id: getSingleEventInfo.event_id,
                event_type: getSingleEventInfo.isOnline ? "Online" : "Offline",
                user_details: {
                  first_name: formik.values.name,
                  last_name: "",
                },
                donation: {
                  amount: state?.donate_Amount_Value,
                },
              }}
              offerData={props?.offerData}
              subscriptionData={props?.subscription}
            />
          )}
        </div>
        {/* <div className="mt-3 d-flex justify-content-center">
            
            
          </div>{" "} */}
      </Col>
    </React.Fragment>
  );
};

EventPaymentMain.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  add_rsvp_events: PropTypes.func.isRequired,
  rsvp_edit_perticular_event_request: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  allData: state.rsvpEvent.transactional_id,
  onboarding: state.onboarding.restaurantDetails,
  subscription: state.onboarding.onboard_subscription_details,
});

export default connect(mapStateToProps, {
  add_rsvp_events,
  razor_pay_create_order,
  razor_payment,
  rsvp_edit_perticular_event_request,
})(withRouter(EventPaymentMain));

const theme = createTheme({
  palette: {
    primary: { main: "#EE3A23" }, // Purple and green play nicely together.
    secondary: { main: "#9E9E9E" }, // This is just green.A700 as hex.
  },
});

const PaymentsInfo = (props) => {
  const [data, setData] = React.useState(props.data);
  const [view, setView] = React.useState(false);
  return (
    <div>
      <Row style={{ backgroundColor: "#ffffff", padding: "15px" }}>
        <Col xs={2}>
          <Radio
            checked={data.id === props.selectedValue ? true : false}
            onChange={(e) => {
              setView(true);
              props.handlePaymentType(data.id);
            }}
            value={data.id}
            name="radio-button-demo"
            color="primary"
            inputProps={{ "aria-label": data.id }}
          />
        </Col>
        <Col xs={2}>
          <img src={data.icon} alt="Icon pic" />
        </Col>
        <Col xs={8}>
          <b>{data.title}</b>
        </Col>
      </Row>
      {data.value === "2" && props.selectedValue === "2" && (
        <Container style={{ padding: "20px" }}>
          <h5>Send a Request to</h5>
          <br />
          <b>Enter Mobile Number</b>
          <br />
          <PhoneComponent />
          <div class="mt-3 d-flex">
            <button
              type="button"
              class="onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
              title="Cancel Button"
            >
              Cancel
            </button>
            <button
              type="button"
              class="onboarding_button_link_reusable onboarding_button_link_reusable_red"
              title="Save Button"
            >
              Send Link
            </button>
          </div>
        </Container>
      )}
    </div>
  );
};

export const PhoneComponent = (props) => {
  return (
    <Row>
      <Col xs={12} md={8}>
        <Row>
          <Col xs={4} className="pr-0">
            <Form.Group controlId={"country_code"}>
              <FormControl variant="outlined" className="w-100">
                <Select
                  disabled
                  value={+91}
                  // onChange={handleChangeCode}
                  inputProps={{
                    name: "code",
                  }}
                  IconComponent={KeyboardArrowDownIcon}
                >
                  <option value={+91}>{props.country_code}</option>
                </Select>
              </FormControl>
            </Form.Group>
          </Col>
          <Col xs={8}>
            <Form.Group>
              <TextField
                disabled
                id="outlined-basic"
                label="Phone Number"
                variant="outlined"
                className="w-100"
                value={props.mobile_number}
              />
            </Form.Group>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

const PaymentSuccessFailedModel = (props) => {
  return (
    <React.Fragment>
      <Modal show={props.open} size="md" centered>
        <Modal.Body className="p-0">
          <div className="pt-3 pb-3" style={{ backgroundColor: "#FFFBEE" }}>
            <Col>
              <div className="row">
                <div className="col-9 f11-400">
                  Event ID :{" "}
                  <span className="f11-500" style={{ color: "#F85032" }}>
                    {props.paymentSuccessData &&
                      props.paymentSuccessData.event_id}
                  </span>
                  <span className="badge badge-warning f10-700 w-25 text-white ml-4">
                    Offline
                  </span>
                </div>
                <div
                  className="col-3"
                  align="right"
                  onClick={() => {
                    props.setOpenTract();
                  }}
                >
                  <i className="fa fa-times" aria-hidden="true"></i>
                </div>
              </div>
            </Col>
            <Col>
              <h1 className="f28-500 mt-1 mb-3" style={{ fontWeight: 700 }}>
                Payment {props.success ? "Success" : "Failed"}
              </h1>
              <Row>
                <Col xs={2}>
                  <img
                    src={require(`../../../../assets/images/superadmin/ordericon/${
                      props.success ? `success` : `failed`
                    }.svg`)}
                    width="45px"
                    heigth="15px"
                    alt={props.success ? "success" : "Failed"}
                  />{" "}
                </Col>
                <Col xs={10} className="f12-400" style={{ paddingTop: "10px" }}>
                  {props.success
                    ? "Your payment has been successfully made"
                    : "Your payment has been declined"}
                </Col>
              </Row>
            </Col>
          </div>
          <div
            className="pt-3 pb-3 mt-2"
            style={{ backgroundColor: "#FFF3CF" }}
          >
            <Col>
              <div className="w-100 f10-400 mb-2" style={{ color: "#717171" }}>
                Event Ticket Number :{" "}
                <span className="f11-500" style={{ color: "#F85032" }}>
                  214536878
                </span>
              </div>
              <Row>
                <Col xs={9}>
                  <span className="f13-700">
                    {props.paymentSuccessData.adult_count} Adults |{" "}
                    {props.paymentSuccessData.kids_count} Child
                  </span>
                  {/* <br /> */}
                  <p className="f10-400 mt-1" style={{ color: "#757575" }}>
                    {props.paymentSuccessData.seat_number
                      ? props.paymentSuccessData.seat_number.map(
                          (data, index) => {
                            return (
                              <React.Fragment key={index}>
                                {data},{" "}
                              </React.Fragment>
                            );
                          }
                        )
                      : "Seat Selection Not Available at this time, will be assigned at The Event"}
                  </p>
                </Col>
              </Row>
            </Col>
          </div>
          <div
            className="pt-3 pb-3 mt-2"
            style={{ backgroundColor: "#F3F3F3" }}
          >
            <Col>
              <div className="w-100 f10-400 mb-2" style={{ color: "#717171" }}>
                Transaction ID :{" "}
                <span className="f11-500" style={{ color: "#F85032" }}>
                  214536878
                </span>
              </div>
              <Row>
                <Col xs={6}>
                  <span className="f11-700">
                    {moment(props.paymentSuccessData.seat_number).format(
                      "Do MMM YYYY"
                    )}
                  </span>
                  {/* <br /> */}
                  <p className="f10-400" style={{ color: "#717171" }}>
                    Date
                  </p>
                </Col>
                <Col xs={6}>
                  <span className="f11-700">
                    {moment(props.paymentSuccessData.seat_number).format(
                      "hh : mm A"
                    )}
                  </span>
                  {/* <br /> */}
                  <p className="f10-400" style={{ color: "#717171" }}>
                    Time
                  </p>
                </Col>
              </Row>
            </Col>
          </div>
          <div
            className="pt-3 pb-3 mt-2"
            style={{ backgroundColor: "#F9F9F9" }}
          >
            <Col>
              <table style={{ width: "100%" }}>
                <tbody>
                  <tr className="mb-2">
                    <td>
                      <span className="f12-700">Sub Total</span>
                    </td>
                    <td>
                      <span className="f14-700">
                        ₹
                        {props.paymentSuccessData &&
                          props.paymentSuccessData.payment_data &&
                          props.paymentSuccessData.payment_data.total_amount -
                            props.paymentSuccessData.payment_data.donate_amount}
                      </span>
                    </td>
                  </tr>
                  <tr className="mb-3">
                    <td className="f12-400 py-2" style={{ color: "#9E9E9E" }}>
                      Service Charge
                    </td>
                    <td className="f12-400 py-2" style={{ color: "#212121" }}>
                      ₹0
                    </td>
                  </tr>
                  <tr className="mb-2">
                    <td className="f12-400" style={{ color: "#9E9E9E" }}>
                      Donation
                    </td>
                    <td className="f12-400" style={{ color: "#212121" }}>
                      ₹
                      {props.paymentSuccessData &&
                        props.paymentSuccessData.payment_data &&
                        props.paymentSuccessData.payment_data.donate_amount}
                    </td>
                  </tr>

                  <tr
                    style={{
                      backgroundColor: "#F8F8F8",
                    }}
                  >
                    <td style={{ paddingTop: "5px", paddingBottom: "5px" }}>
                      <span className="f12-700">Total Amount Paid</span>
                    </td>
                    <td style={{ paddingTop: "5px", paddingBottom: "5px" }}>
                      <span className="f14-700">
                        ₹
                        {props.paymentSuccessData &&
                          props.paymentSuccessData.payment_data &&
                          props.paymentSuccessData.payment_data.total_amount}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </Col>
          </div>
          <Col
            className="py-4 px-4 mt-2"
            style={{ borderTop: "1px solid #E0E0E0" }}
          >
            <button
              type="button"
              className="py-3 onboarding_button_link_reusable onboarding_button_link_reusable_red w-100"
              title="Done"
              onClick={() => {
                props.setOpenTract();
              }}
            >
              {props.success ? "Done" : "Try Again"}
            </button>
          </Col>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

const paymentData = [
  // {
  //   id: 6,
  //   title: "Pay later",
  //   value: "Pay later",
  //   icon: require("../../../../assets/images/superadmin/ordericon/credit-card (1).svg"),
  //   show: true,
  // },
  {
    id: 9,
    title: "Cash",
    value: "Cash",
    icon: require("../../../../assets/images/superadmin/ordericon/credit-card (1).svg"),
    show: true,
  },
  {
    id: 8,
    title: "External Wallet",
    value: "Wallet",
    icon: require("../../../../assets/images/superadmin/ordericon/credit-card (1).svg"),
    show: true,
  },
  {
    id: 1,
    title: "BHIM UPI",
    value: "BHIM UPI",
    icon: require("../../../../assets/images/Orders/sdmlM4R-_400x400.png"),
    show: false,
  },
  {
    id: 2,
    title: "PayTM",
    value: "PayTM",
    icon: require("../../../../assets/images/superadmin/ordericon/credit-card (1).svg"),
    show: false,
  },
  {
    id: 3,
    title: "Debit Card",
    value: "Debit Card",
    icon: require("../../../../assets/images/superadmin/ordericon/credit-card (1).svg"),
    show: true,
  },
  {
    id: 4,
    title: "Credit Card",
    value: "Credit Card",
    icon: require("../../../../assets/images/superadmin/ordericon/phone-credit card-money-finance.svg"),
    show: true,
  },
  {
    id: 5,
    title: "Net Banking",
    value: "Net Banking",
    icon: require("../../../../assets/images/superadmin/ordericon/online-payment.svg"),
    show: false,
  },
];

const ExternalReference = (props) => {
  const [ref, setRef] = useState("");
  const [refErr, setRefErr] = useState(false);

  const handleDesc = (e) => {
    if (!e.target.value) {
      setRefErr(true);
    } else {
      setRefErr(false);
      setRef(e.target.value);
    }
  };

  const submitCancel = () => {
    props.submitExternal(ref);
  };

  return (
    <React.Fragment>
      <Modal show={true} onHide={props.hideCancel} centered>
        <Modal.Header className="border-0" closeButton>
          <div className="f18-700">Enter Transaction Reference</div>
        </Modal.Header>
        <Modal.Body>
          <div className="f18-500 mt-2 mb-4">
            <Form.Group>
              <TextField
                id="reference"
                variant="outlined"
                label="Reference"
                name="reference"
                className={`w-100  ${refErr ? "enError" : ""}`}
                onChange={handleDesc}
                value={ref}
              />
            </Form.Group>
          </div>
          <div className="mt-4">
            <div className="row">
              <div className="col-6">
                <Button
                  variant="outline-secondary"
                  className="btn-md py-2 mb-2"
                  style={{ width: "90%" }}
                  onClick={props.hideCancel}
                >
                  Cancel
                </Button>
              </div>
              <div className="col-6">
                <Button
                  variant="danger"
                  className="btn-md py-2 mb-2 w-100"
                  onClick={submitCancel}
                >
                  Done
                </Button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};
